import keycloak from "./keycloak";

export function logout() {
  // Clear client-side session hints; user settings are persisted server-side anyway.
  try {
    localStorage.removeItem("mkzugferd.currentCompanyId");
    localStorage.removeItem("mkzugferd.locale");
    localStorage.removeItem("mkzugferd.theme");
  } catch (_) {
    // ignore
  }

  if (process.env.VUE_APP_DISABLE_AUTH === "true") {
    window.location.href = "/";
    return;
  }

  const redirectUri = `${window.location.origin}/`;
  keycloak.logout({
    redirectUri, // Redirect to app root after logout
  });
}
